<div class="filter-container position-relative w-100">
  <div>
    <app-filter-search
      class="filter-dropdown"
      [placeholder]="translationScope+'.search' | transloco"
      [value]="filter.search"
      (search)="updateSearchFilter($event)"
    ></app-filter-search>
  </div>

  <div
    class="region-filter"
    app-filter-dropdown
    [items]="regions"
    [showSelectionCount]="true"
    [(selectedItems)]="selectedRegions"
    [placeholder]="translationScope+'.region' | transloco"
    [bindLabel]="'name'"
    [bindValue]="'id'"
    (close)="updateRegionsFilter()"
    (clear)="clearRegionsFilter()"
  ></div>

  <ng-container *ngIf="!HideDate">
    <button class="shadow-button" (click)="datePickerDropdown.open(true)">
      {{ getDateFilterLabel(filter.fromDate, filter.toDate) === 'Dato' ? (translationScope + '.date' | transloco) : getDateFilterLabel(filter.fromDate, filter.toDate) }}
      <div class="arrow-down" [ngStyle]="datePickerDropdown.isOpen && {'transform': 'rotateX(180deg);'}"></div>
    </button>

    <div
      (click)="$event.stopPropagation()"
      ngBootstrapDropdown
      #datePickerDropdown="ngDropDown"
      class="dropdown-menu rounded-0 shadow bg-white border-0"
    >
      <!-- Date Filter -->
      <app-date-filter
        [fromDate]="filter.fromDate"
        [toDate]="filter.toDate"
        (save)="saveDate(filter, $event) && datePickerDropdown.close()"
        (clear)="clearDate(filter, $event)"
      >
      </app-date-filter>
    </div>
  </ng-container>

  <div class="reset-filter" (click)="resetFiltersAndSearch()">
    <img src="assets/icons/refresh.svg" alt="">
    <span>{{ translationScope + '.reset' | transloco }}</span>
  </div>
</div>

<button class="filter-button" (click)="openFilterBottomSheet()" [disabled]="!isFiltersLoaded">
  <mat-icon class="material-symbols-outlined">filter_alt</mat-icon>
  <span>{{ 'Filters' }}</span>
  <div *ngIf="activeFilterCount > 0" class="bg-selection-count">
    <span class="selection-count">{{ activeFilterCount }}</span>
  </div>
</button>

